<template>
  <div class="picklr-card-wrapper">
  <div class="green-border-box picklr-item white-bg">
    <div class="send-msg-check" v-if="userRole=='super-admin'">
      <input type="checkbox" v-bind:value="picklr.id" v-bind:id="picklr.id" :checked="isUserChecked(picklr.id)" @change="checkPicklr($event)">
    </div>

    <router-link :to="'/'+userUrl+'/picklrs/' + picklr.id">
      <div class="col-xs-12 profile-details">
        <div class="green-border-box profile-photo">
          <img
            v-square-img
            :src="picklr.image + '?w=150&q=50'?picklr.image:imageLoadOnError"
            @error="imageLoadOnError"
          >
        </div>
        <div class="afterImage">
          <div
            class="profile-name"
            :title="picklr.name"
            v-autosize="{ target: 14, min: 12 }"
          >{{picklr.name}}</div>
          <div
            style="user-select:all"
            class="phone-number"
            :title="picklr.mobile_number"
            v-autosize="{ target: 12, min: 11 }"
          >{{picklr.mobile_number | phone}}</div>
          <div
            style="user-select:all"
            class="email"
            :title="picklr.email"
          >{{picklr.email}}</div>
          <div class="rating">
            <img v-for="n in picklr.rating" :key="n" src="/img/Alerts/picklerating_icon.png">
          </div>
          <div v-if="picklr.last_active_device" style="display:inline;">
            <span
              class="app-gps-status-using-no"
              title="GPS Status - No"
              v-autosize="{ target: 12, min: 11 }"
              v-if="picklr.last_active_device.app_gps_status === 'no'"
            > &nbsp;
            </span>

            <span
              class="app-gps-status-using-app"
              title="GPS Status - While Using App"
              v-autosize="{ target: 12, min: 11 }"
              v-if="picklr.last_active_device.app_gps_status === 'while_using_app'"
            > &nbsp;
            </span>

            <span
              class="app-gps-status-always-allowed"
              title="GPS Status - Always Allowed"
              v-autosize="{ target: 12, min: 11 }"
              v-if="picklr.last_active_device.app_gps_status === 'alway_allowed'"
            > &nbsp;
            </span>
          </div>
          <div v-if="picklr.last_active_device" style="display:inline;">
            <span
              class="app-notification-no"
              title="GPS Notification - No"
              v-autosize="{ target: 12, min: 11 }"
              v-if="picklr.last_active_device.app_notification === 'no'"
            > &nbsp;
            </span>

            <span
              class="app-notification-yes"
              title="GPS Notification - Yes"
              v-autosize="{ target: 12, min: 11 }"
              v-if="picklr.last_active_device.app_notification === 'yes'"
            > &nbsp;
            </span>
          </div>
          <span v-if="picklr.last_active_device"
              class="app-version"
              title="App Version"
              v-autosize="{ target: 12, min: 11 }"
            >
              {{picklr.last_active_device.app_version}}
          </span>
              <div>
                <a class="address">
                  <div>
                    <div v-for="(zip_code, index) in picklr.zip_codes" :key="zip_code.id" >{{zip_code.formatted_address}}<div v-if="index < (picklr.zip_codes.length - 1)"></div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="date-time-inline">Registered: {{picklr.date}}, {{picklr.time}}</div>
        </div>
      </div>
    </router-link>
    <div class="col-xs-12 nopadd stats-row">
      <div class="part part-white">
        <h4>{{picklr.completed_pickls_count}}</h4>Completed
      </div>
      <div
        class="part part-white"
        :class="{'due-alert': picklr.current_credits >= $store.state.settings.credit_payment_threshold}"
      >
        <!-- Have currency formatting -->
        <h4>${{picklr.current_credits}}</h4>
        <span>Due</span>
      </div>
      <div class="part part-grey">
        <h4 v-if="picklr.credits_paid_sum">${{picklr.credits_paid_sum}}</h4>
        <h4 v-else>$0</h4>Paid
      </div>
    </div>
  </div>

</div>

</template>

<script>

export default {
  name: 'PicklrItem',
  data () {
    return {
      userRole: 'staff',
      userUrl: 'staff'
    }
  },
  props: {
    picklr: {},
    selectedPicklrs: {},
    selectAllPicklrs: false
  },
  methods: {
    imageLoadOnError () {
      this.picklr.image = '/img/pickl-logo.png'
    },
    checkPicklr: function (e) {
      if (e.target.checked) {
        this.$emit('updateCheckedUsers', parseInt(e.target.value), 'added')
      } else {
        this.$emit('updateCheckedUsers', parseInt(e.target.value), 'removed')
      }
    },
    isUserChecked (picklrId) {
      if (this.selectAllPicklrs) {
        return true
      }
      if (!this.selectAllPicklrs) {
        return false
      }
      if (this.selectedPicklrs.indexOf(picklrId) === -1) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    let userData = this.$store.state.userData
    this.userRole = userData.role
    if (this.userRole === 'super-admin') {
      this.userUrl = 'sadmin'
    } else {
      this.userUrl = 'staff'
    }
  }
}
</script>

<style scoped>
.picklr-card-wrapper {
  width: 100%;
  height: 100%;
}

.picklr-item {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.profile-details {
  padding: 10px;
}

.profile-details .profile-photo {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: top;
  display: inline-block;
  position: relative;
  margin-top: 4px;
}

.profile-details .profile-photo img {
  position: absolute;
}

.profile-details .afterImage {
  width: calc(100% - 58px);
  display: inline-block;
  padding: 4px 6px 4px 0;
}

.profile-details .profile-name {
  text-transform: capitalize;
  color: #1a202c;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 20px;
  overflow: hidden;
}

.profile-details .rating img {
  width: 10px;
  height: 10px;
  margin-right: 2px;
}

.part {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  color: #4a5568;
  font-size: 11px;
}

.part-white {
  background: #fff;
  border-left: 1px solid #edf2f7;
}

.part-grey {
  background: #f7f8fa;
}

.part h4 {
  color: #1a202c;
  font-size: 15px;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 4px;
}

.due-alert h4,
.due-alert span {
  color: #e53e3e;
}

.due-alert span {
  border-radius: 360px;
  border: 1px solid #e53e3e;
  padding: 0 10px;
  line-height: 18px;
  display: inline-block;
  font-size: 11px;
}

.date-time-inline {
  font-weight: 400;
  font-size: 10px;
  color: #718096;
  line-height: 16px;
  margin-top: 4px;
}

.stats-row {
  display: flex;
  margin-top: auto;
}

.contact-number {
  color: #4a5568;
  line-height: 18px;
}

.phone-number,
.phone-number:hover,
.phone-number:focus,
.phone-number:active {
  padding-left: 16px;
  background-image: url("/img/Picklr/call_icon.png");
  background-position: center left;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #4a5568;
  text-decoration: none;
}

.email {
  padding-left: 16px;
  background-image: url("/img/Picklr/email_icon.png");
  background-position: center left;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #4a5568;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.app-gps-status-using-app,
.app-gps-status-using-app:hover,
.app-gps-status-using-app:focus,
.app-gps-status-using-app:active,
.app-gps-status-using-no,
.app-gps-status-using-no:hover,
.app-gps-status-using-no:focus,
.app-gps-status-using-no:active,
.app-gps-status-always-allowed,
.app-gps-status-always-allowed:hover,
.app-gps-status-always-allowed:focus,
.app-gps-status-always-allowed:active,
.app-version,
.app-version:hover,
.app-version:focus,
.app-version:active,
.app-notification-yes,
.app-notification-yes:hover,
.app-notification-yes:focus,
.app-notification-yes:active,
.app-notification-no,
.app-notification-no:hover,
.app-notification-no:focus,
.app-notification-no:active {
  padding-left: 16px;
  background-position: center left;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #4a5568;
  text-decoration: none;
}

.app-gps-status-using-app { background-image: url("/img/Picklr/GPS_green_16x16.png"); }
.app-gps-status-using-no { background-image: url("/img/Picklr/GPS_gray_16x16.png"); }
.app-gps-status-always-allowed { background-image: url("/img/Picklr/GPS_purple_16x16.png"); }
.app-version { background-image: url("/img/Picklr/AppVersion_gray_16x16.png"); }
.app-notification-yes { background-image: url("/img/Picklr/Notification_purple_16x16.png"); }
.app-notification-no { background-image: url("/img/Picklr/Notification_gray_16x16.png"); }

@media only screen and (max-width: 767px) {
  .part {
    padding: 10px 0;
    border-top: 1px solid #edf2f7;
  }
}

.send-msg-check {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.send-msg-check input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.address {
  padding-left: 16px;
  background-image: url("/img/Picklr/address_icon.png");
  background-position: top left;
  background-repeat: no-repeat;
  background-size: 11px 13px;
  font-weight: 500;
  font-size: 11px;
  line-height: 15px;
  color: #4a5568;
  text-decoration: none;
  margin-bottom: 4px;
  display: inline-block;
}
</style>
